import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { updateTxState } from '../../actions'
import {
  cancelModalConfirmation,
  closeModalConfirmation,
  openModalConfirmation,
} from '../../actions/modal_confirmation'
import { fetchTransactionsDeclineDefinitions } from '../../actions/transactions_decline_definitions'
import {
  TX_STATUS_COMPLETED,
  TX_STATUS_FAILED,
  TX_STATUS_HOLD,
  TX_STATUS_NEW,
  TX_STATUS_POST_PROCESSING,
  TX_STATUS_PROCESSING,
  TX_STATUS_RESTARTED,
  TX_STATUS_CUSTOMER_REVIEW,
} from '../../config'
import ConfirmationModal from '../confirmation_modal'
import RestartConfirmationModal from './restart_confirmation_modal'

class TxDetailsButtons extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { missingUserInfo: [] }
  }

  attemptApprove = () => {
    this.props.attemptApprove(this.openModalApprove)
  }

  openModalApprove = () => {
    this.props.openModalConfirmation(TX_STATUS_COMPLETED)
  }

  componentDidMount() {
    const missingInfo = this.props.getMissingUserInfo()
    if (missingInfo.length) {
      this.setState({ missingUserInfo: missingInfo })
    }
    this.props.fetchTransactionsDeclineDefinitions()
  }

  isApprove() {
    const { errors } = this.props.userTx
    const errorsCodes = []
    const isActiveStates = []
    errors.forEach((i) => {
      errorsCodes.push(i.error_code.error_code_id)
      isActiveStates.push(i.is_active)
    })
    if (errorsCodes.includes(2006)) {
      return isActiveStates.includes(false)
    }
    return true
  }

  render() {
    const { props } = this
    const {
      currentState,
      newState,
      openModalConfirmation,
      closeModalConfirmation,
      isModalConfirmationOpen,
      id,
      cancelModalConfirmation,
      isRestartEnabled,
      errors,
      transactionsDeclineDefinitions,
    } = props
    if (currentState === TX_STATUS_RESTARTED) {
      return null
    }
    let state = newState || currentState
    const restart = !!(
      state === TX_STATUS_FAILED ||
      state === TX_STATUS_POST_PROCESSING ||
      state === TX_STATUS_CUSTOMER_REVIEW
    )

    const restartBtn = (
      <Button
        className='text-center'
        bsPrefix='btn btn-w-m btn-success'
        size={'lg'}
        onClick={() => openModalConfirmation(TX_STATUS_RESTARTED)}
      >
        <i className='fa fa-refresh' /> Restart
      </Button>
    )
    const holdBtn = (
      <Button
        className='text-center'
        style={{ backgroundColor: '#A9A9A9', color: 'white' }}
        bsPrefix='btn btn-w-m '
        size={'lg'}
        onClick={() => openModalConfirmation(TX_STATUS_HOLD)}
      >
        <i className='fa fa-pause' /> Hold
      </Button>
    )
    const restartBtnDisabled = (
      <Button className='text-center' bsPrefix='btn btn-w-m btn-success disabled' size={'lg'}>
        <i className='fa fa-refresh' /> Restart
      </Button>
    )
    const approveBtn = (
      <Button
        disabled={state === TX_STATUS_PROCESSING}
        size={'lg'}
        bsPrefix='btn btn-w-m btn-primary'
        onClick={this.attemptApprove}
      >
        <i className='fa fa-check' />
        Approve
      </Button>
    )
    return (
      <div style={{ height: 45, textAlign: 'center' }} className='m-b m-t'>
        {(state === TX_STATUS_NEW ||
          state === TX_STATUS_HOLD ||
          state === TX_STATUS_PROCESSING ||
          state === TX_STATUS_POST_PROCESSING ||
          state === TX_STATUS_CUSTOMER_REVIEW) && (
          <Button
            disabled={state === TX_STATUS_PROCESSING}
            bsPrefix='btn btn-w-m btn-danger'
            onClick={() => openModalConfirmation(TX_STATUS_FAILED)}
          >
            <i className='fa fa-exclamation-triangle' /> Decline
          </Button>
        )}
        {(state === TX_STATUS_HOLD || state === TX_STATUS_PROCESSING) && this.isApprove() && approveBtn}
        {restart && isRestartEnabled && restartBtn}
        {state === TX_STATUS_COMPLETED && holdBtn}
        {state === TX_STATUS_FAILED && !isRestartEnabled && restartBtnDisabled}
        {state === TX_STATUS_RESTARTED ? (
          <RestartConfirmationModal
            errors={errors}
            id={id}
            isModalConfirmationOpen={isModalConfirmationOpen}
            title='Confirm'
            close={closeModalConfirmation}
            cancel={cancelModalConfirmation}
          />
        ) : (
          <ConfirmationModal
            id={id}
            isModalConfirmationOpen={isModalConfirmationOpen}
            title='Confirm'
            close={closeModalConfirmation}
            cancel={cancelModalConfirmation}
            transactionsDeclineDefinitions={transactionsDeclineDefinitions}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isModalConfirmationOpen: state.modalConfirmation.isModalConfirmationOpen,
  newState: state.modalConfirmation.newState,
  isFetching: state.txById.isFetching,
  isFetchingTransactionsDeclineDefinitions: state.fetchTransactionsDeclineDefinitions.isFetching,
  transactionsDeclineDefinitions: state.fetchTransactionsDeclineDefinitions.data,
  userTx: state.txById.userTx,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      openModalConfirmation,
      closeModalConfirmation,
      cancelModalConfirmation,
      fetchTransactionsDeclineDefinitions,
      updateTxState,
      navigateHome: () => ownProps.history.push('/'),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxDetailsButtons))
